import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-station_navigation",
  "use": "icon-station_navigation-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-station_navigation\"><mask id=\"icon-station_navigation_a\" height=\"20\" maskUnits=\"userSpaceOnUse\" width=\"20\" x=\"0\" y=\"0\"><path d=\"m0 0h20v20h-20z\" fill=\"#d9d9d9\" /></mask><g mask=\"url(#icon-station_navigation_a)\"><path d=\"m10.94 16.12-2.02-5.07-5.07-2.05-.03-.53 12.37-4.69-4.72 12.34zm.26-1.64 3.57-9.28-9.31 3.54 4.08 1.66z\" fill=\"#1c1b1f\" /></g><path d=\"m0 0h20v20h-20z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/station_navigation.svg
// module id = IvGj
// module chunks = 87